import type { FaireProductEntity } from "../../entity_types/product";

export const p_jw34qyt4u5: FaireProductEntity = {
  token: "p_jw34qyt4u5",
  type: "product",
  name: "Jon & Vinny's Pancake Mix",
  brandToken: "b_8r7b7k3ydp",
  brandName: "Jon & Vinny's",
  imageUrl: "https://cdn.faire.com/fastly/7c646e2aade9680f62550323cf9f1c6a5923ed708d179924ddf50d9edffc7b49.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/185c3170d0db03b0a678373521fdabbbd4350a1b463603dd0c50129ed8918e70.png"
  ],
  priceDollars: 8,
  description: "About this product: \nHost your very own Jon & Vinny’s Pancake Party!\nWith our signature pancake mix, packaged in a resealable bag to keep things fresh, this blend is simple to use - just add buttermilk, eggs, unsalted butter and your wooden spoon to make perfectly fluffy pancakes. Serve them however you like and enjoy these pancakes anytime! \n\nYields: 25 three-inch pancakes\nShelf Life: 12 months\nSize:\n* 1 bag\n* 16 oz / 454 g\n\n",
  tags: [],
  msrpDollars: 12.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:58:00.085Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
